import { useState, useRef, useEffect } from "react";
import { IoClose, IoCopyOutline, IoDownloadOutline } from "react-icons/io5";
import { CgTranscript } from "react-icons/cg";

export function TranscriptCell({ item }) {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const itemRefs = useRef([]);

  const parsedItem =
    typeof item === "string" ? JSON.parse(item) : item;

  // Show all items (like WhatsApp search)
  const filtered = Array.isArray(parsedItem) ? parsedItem : [];

  // Capitalize role
  const getDisplayRole = (item) => {
    const role = item.role || "user";
    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  // Avatar first letter
  const firstLetterUpper = (item) =>
    getDisplayRole(item).charAt(0).toUpperCase();

  // Escape regex special chars
  const escapeRegex = (str) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // WhatsApp-style highlight
  const highlightText = (text, query) => {
    if (!query) return text;

    const safeQuery = escapeRegex(query);
    const regex = new RegExp(`(${safeQuery})`, "gi");

    return text.split(regex).map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={index} className="transcript-highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);

    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(transcriptText);
      alert("Transcript copied");
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const transcriptText = filtered
    .map((item) => {
      const role = getDisplayRole(item);
      const time = formatTime(
        item.timestamp || item.time || item.createdAt
      );

      return `[${time}] ${role}: ${item.displayText || item.text || ""}`;
    })
    .join("\n\n");

  const now = new Date();

  const formatted =
    String(now.getDate()).padStart(2, "0") +
    String(now.getMonth() + 1).padStart(2, "0") +
    now.getFullYear() +
    "_" +
    String(now.getHours()).padStart(2, "0") +
    String(now.getMinutes()).padStart(2, "0");

  const handleDownload = () => {
    const blob = new Blob([transcriptText], {
      type: "text/plain;charset=utf-8",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `transcript_${formatted}.txt`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (!search.trim()) return;

    const firstMatchIndex = filtered.findIndex((item) => {
      const text = (item.displayText || item.text || "").toLowerCase();

      return text.includes(search.toLowerCase());
    });

    if (
      firstMatchIndex !== -1 &&
      itemRefs.current[firstMatchIndex]
    ) {
      itemRefs.current[firstMatchIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [search, filtered]);

  return (
    <>
      {/* Trigger */}
      <CgTranscript
        onClick={() => setShowModal(true)}
        style={{
          fontSize: "20px",
          cursor: "pointer",
          color: "#0782D5",
        }}
      />

      {/* Modal */}
      {showModal && (
        <div
          className="transcript-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="transcript-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}

            {/* <div className="transcript-header">
              <div className="transcript-leftHeader">
                <span className="transcript-title">
                  Transcript
                </span>
              </div>

              <div className="transcript-rightHeader">
                <input
                  type="text"
                  placeholder="Search transcript..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="transcript-searchInput"
                />

                <button
                  className="transcript-actionBtn"
                  onClick={handleCopy}
                  title="Copy Transcript"
                >
                  <IoCopyOutline size={16} />
                </button>

                <button
                  className="transcript-actionBtn"
                  onClick={handleDownload}
                  title="Download Transcript"
                >
                  <IoDownloadOutline size={16} />
                </button>


                <button
                  className="transcript-closeBtn"
                  onClick={() => setShowModal(false)}
                >
                  <IoClose size={18} />
                </button>
              </div>
            </div> */}

            <div className="transcript-header">
              <div className="transcript-headerLeft">
                <span className="transcript-title">
                  Transcript
                </span>
              </div>

              <div className="transcript-headerRight">
                <input
                  type="text"
                  placeholder="Search transcript..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="transcript-searchInput"
                />

                <button
                  className="transcript-actionBtn"
                  onClick={handleCopy}
                  title="Copy Transcript"
                >
                  <IoCopyOutline size={16} />
                </button>

                <button
                  className="transcript-actionBtn"
                  onClick={handleDownload}
                  title="Download Transcript"
                >
                  <IoDownloadOutline size={16} />
                </button>

                <button
                  className="transcript-closeBtn"
                  onClick={() => {
                    setShowModal(false);
                    setSearch("");
                  }}
                >
                  <IoClose size={18} />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="transcript-body">
              {filtered.map((item, index) => (
                // <div key={index} className="transcript-item">
                <div
                  key={index}
                  className="transcript-item"
                  ref={(el) => (itemRefs.current[index] = el)}
                >

                  <div className="transcript-row">
                    <div
                      className="transcript-avatar"
                      // style={{ background: "#0782D5" }}
                      style={{
                        background:
                          item.role === "customer"
                            ? "#6B64AD"
                            : "#283C50",
                      }}
                    >
                      {firstLetterUpper(item)}
                    </div>

                    <span
                      className="transcript-name"
                      // style={{ color: "#0782D5" }}
                      style={{
                        color:
                          item.role === "customer"
                            ? "#6B64AD"
                            : "#283C50",
                      }}
                    >
                      {getDisplayRole(item)}
                    </span>
                    <span className="transcript-time">
                      {formatTime(item.timestamp || item.time || item.createdAt)}
                    </span>
                  </div>
                  <div className="transcript-text">
                    {highlightText(item.displayText || item.text, search)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}